export const environment = {
    production: false,
    apiurls: {
        baseUrl: 'https://boxing-api.hardkore.tech/api/'
    }
};

